module.exports = __webpack_public_path__ + "static/media/connection_service_region_1.51a1f952.png";